import React, {useEffect, useState} from 'react';
import {Modal} from 'antd';
import {TagSelect} from '../TagSelect';

interface TagPickerModalProps {
  open: boolean;
  value: string[];
  onCancel: () => void;
  onOk: (tags: string[]) => void;
}

export function TagPickerModal({open, value, onCancel, onOk}: TagPickerModalProps) {
  const [innerValue, setInnerValue] = useState<string[]>([]);

  useEffect(() => {
    if (open) setInnerValue((value || []));
  }, [open, value]);

  return (
    <Modal
      title="选择标签"
      visible={open}
      onCancel={onCancel}
      onOk={() => onOk(innerValue)}
    >
      <TagSelect value={innerValue} onChange={setInnerValue}/>
    </Modal>
  );
}